import { Pipe, PipeTransform } from '@angular/core';
import { SelectOption, ViolationTypeOptions } from '@fleet-beat/core';

@Pipe({
  name: 'violationTypePipe',
})
export class ViolationTypePipe implements PipeTransform {
  transform(value: unknown): string | null {
    if (!value) return null;
    return ViolationTypeOptions.find((status: SelectOption) => status.value === value).label;
  }
}
